export const degreeOptions = [
  { label: "B.Tech", value: "btech" },
  { label: "M.Tech", value: "mtech" },
  { label: "B.Sc", value: "bsc" },
  { label: "M.Sc", value: "msc" },
  { label: "BCA", value: "bca" },
  { label: "MCA", value: "mca" },
  { label: "B.Com", value: "bcom" },
  { label: "M.Com", value: "mcom" },
  { label: "BA", value: "ba" },
  { label: "MA", value: "ma" },
  { label: "BBA", value: "bba" },
  { label: "MBA", value: "mba" },
  { label: "Diploma", value: "diploma" },
  { label: "PhD", value: "phd" },
  { label: "Other", value: "other" },
];

export const FasionOptions = [
  { label: "Haute coture", value: "Haute coture" },
  { label: "Fast fashion", value: "Fast fashion" },
  { label: "Sustainable fashion", value: "Sustainable fashion" },
  { label: "Luxury fashion", value: "Luxury fashion" },
];

export const PhotoGraphyOptions = [
  { label: "WildLife", value: "WildLife" },
  { label: "WeddingShoot", value: "WeddingShoot" },
  { label: "Event photography", value: "Event photography" },
  { label: "Photojournalism", value: "Photojournalism" },
];

export const domainOptions = [
  { label: "Select Domain", value: "" },
  { label: "Fashion Designer", value: "Fashion Designer" },
  { label: "photographer", value: "photographer" },
];

export const LocationOptions = [
  { label: "Mumbai", value: "Mumbai" },
  { label: "Pune", value: "Pune" },
  { label: "Bangalore", value: "Bangalore" },
  { label: "Hyderabad", value: "Hyderabad" },
  { label: "Noida", value: "Noida" },
  { label: "Delhi", value: "Delhi" },
  { label: "Gurgaon", value: "Gurgaon" },
];

export const SalaryOptions = [
  { label: "0.5 - 2.4 LPA", value: "0.5 - 2.4 LPA" },
  { label: "2.4 - 4.5 LPA", value: "2.4 - 4.5 LPA" },
  { label: "4.5 - 9.5LPA", value: "4.5 - 9.5LPA" },
  { label: "9.5 - 15 LPA", value: "9.5 - 15 LPA" },
  { label: "above 15 LPA", value: "above 15 LPA" },
];

export const statusOptions = [{
  label: "Active",
  value: "true",
}, {
  label: "Inactive",
  value: "false",
}];

export const planOptions = [
  {label: 'Monthly Plan', value: 'monthly'},
  {label: 'Annual Plan', value: 'annual'},
]

export const flagStatusOptions = ["Remove", "Flagged", "Resolved"].map((flag, index) => ({
  label: flag,
  value: index
}))

export const userTypeOptions = ["Creator", "Business"].map((flag, index) => ({
  label: flag,
  value: String(index)
}))

export const paymentStatusOptions = [
  {label: 'Failed', value: 'FAILED'},
  {label: 'Success', value: 'SUCCESS'},
  {label: 'Pending', value: 'PENDING'},
];

export const amountPaymentOptions = [
  {label: '₹ 179', value: '179'},
  {label: '₹ 1499', value: '1499'},
]